import * as fromDatatype from "../datatype-library/index";

export interface bl_crm_organization_hdr_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.NamespaceDataFieldInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	name: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	guid_parent: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	id_no: fromDatatype.VarcharDatatypeInterface;
	id_type: fromDatatype.VarcharDatatypeInterface;
	phone: fromDatatype.VarcharDatatypeInterface;
	email: fromDatatype.VarcharDatatypeInterface;
	tax_registration_number: fromDatatype.VarcharDatatypeInterface;
	currency: fromDatatype.VarcharDatatypeInterface;
}

export class bl_crm_organization_hdr_RowClass
	implements bl_crm_organization_hdr_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.NamespaceDataFieldInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	name: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	guid_parent: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	id_no: fromDatatype.VarcharDatatypeInterface;
	id_type: fromDatatype.VarcharDatatypeInterface;
	phone: fromDatatype.VarcharDatatypeInterface;
	email: fromDatatype.VarcharDatatypeInterface;
	tax_registration_number: fromDatatype.VarcharDatatypeInterface;
	currency: fromDatatype.VarcharDatatypeInterface;
	entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
	address_line_1: fromDatatype.VarcharDatatypeInterface;
	address_line_2: fromDatatype.VarcharDatatypeInterface;
	address_line_3: fromDatatype.VarcharDatatypeInterface;
	address_line_4: fromDatatype.VarcharDatatypeInterface;
	address_line_5: fromDatatype.VarcharDatatypeInterface;
	country: fromDatatype.VarcharDatatypeInterface;
	state: fromDatatype.VarcharDatatypeInterface;
	city: fromDatatype.VarcharDatatypeInterface;
	postal_code: fromDatatype.VarcharDatatypeInterface;
}
